import { render } from "./AlbumSearch.vue?vue&type=template&id=652753c4"
import script from "./AlbumSearch.vue?vue&type=script&lang=js"
export * from "./AlbumSearch.vue?vue&type=script&lang=js"

import "./AlbumSearch.vue?vue&type=style&index=0&id=652753c4&lang=scss"

import exportComponent from "/Users/michellmonroy/Documents/dev-glider/catalogue-api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__